export const htmlMeta = {
    titleTemplate: "%s - devowl.io Admin UI",
    defaultTitle: "devowl.io Admin UI",
    themeColor: "#000000"
};
